import fbIcon from "../../assets/facebook-logo.png";
import wapIcon from "../../assets/wap_icon.png";
import igIcon from "../../assets/instagram-icon.png";
import ytIcon from "../../assets/youtube-icon.png";
import dcIcon from "../../assets/discord-logo.png";
import xIcon from "../../assets/x-logo.png";

export const iconList = [
  { img: fbIcon, link: "" },
  { img: igIcon, link: "" },
  { img: ytIcon, link: "" },
  { img: dcIcon, link: "" },
  { img: xIcon, link: "" },
  { img: wapIcon, link: "" },
];
